import { IApiBaseResponse } from '~/utils/interface/common';
import axiosClient from './axiosClient';
import { IMaterialType } from '~/utils/interface/material-type';

const url = `api/admin/material-types`;
const materialTypesApi = {
  create(data: IMaterialType) {
    return axiosClient.post<IApiBaseResponse<IMaterialType>>(url, data);
  },
};

export default materialTypesApi;
